import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { SharedIconMenuItemModel } from '@shared-lib/models/shared-icon-menu-item.model';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'cp-multiaction-button',
  imports: [ButtonModule, IconComponent, NgClass, Popover],
  templateUrl: './multiaction-button.component.html',
  styleUrls: ['./multiaction-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiactionButtonComponent {
  @Input() menuItems: MenuItem[];
  @Input() isLoading: boolean;
  @Input() buttonClass: string;
  @Input() iconsHeight = '1rem';
  @Input() iconsWidth = '1rem';

  @ViewChild('menu') menu: Popover;

  protected get iconMenuItems(): SharedIconMenuItemModel[] {
    return (this.menuItems ?? []) as SharedIconMenuItemModel[];
  }

  public toggleMenu(event: MouseEvent): void {
    this.menu.toggle(event);
  }
}
